// Shared so the preview page resolves a notification the way the player's container does.

import type { defineAsyncComponent } from '#imports'
import {
    LazyNimbusNotificationDialogDefaultMessage,
    LazyNimbusNotificationDialogOccupationMessage,
    LazyNimbusNotificationDialogSalaryCheckMessage,
    LazyNimbusNotificationDialogAppReviewRequest,
    LazyNimbusNotificationDialogKycDocumentInquiryMessage,
    LazyNimbusNotificationDialogBounceMessage,
    LazyNimbusNotificationDialogFirstDepositBonusRedeemedMessage,
    LazyNimbusNotificationDialogMoneyLimitsReminderMessage,
} from '#components'
import { MessageType } from '@core/types'

type DialogComponent = ReturnType<typeof defineAsyncComponent>

export const NOTIFICATION_DIALOG_COMPONENTS: Partial<Record<MessageType, DialogComponent | undefined>> & {
    default: DialogComponent
} = {
    default: LazyNimbusNotificationDialogDefaultMessage,
    occupation_check: LazyNimbusNotificationDialogOccupationMessage,
    salary_check: LazyNimbusNotificationDialogSalaryCheckMessage,
    app_review_request: LazyNimbusNotificationDialogAppReviewRequest,
    kyc_document_inquiry: LazyNimbusNotificationDialogKycDocumentInquiryMessage,
    bounce_email_review_profile: LazyNimbusNotificationDialogBounceMessage,
    promotion_first_deposit_bonus_redeemed: LazyNimbusNotificationDialogFirstDepositBonusRedeemedMessage,
    money_limits_reminder: LazyNimbusNotificationDialogMoneyLimitsReminderMessage,
} as const

/** The dialog for a message type, or the generic one when it has none. */
export function notificationDialogComponent(type: MessageType | null | undefined): DialogComponent {
    if (!type) return NOTIFICATION_DIALOG_COMPONENTS.default

    return NOTIFICATION_DIALOG_COMPONENTS[type] ?? NOTIFICATION_DIALOG_COMPONENTS.default
}

// Allowlist, not blocklist: a preview payload carries no `data`, so a component that
// reads it while setting up (kyc_document_inquiry, first_deposit_bonus_redeemed) throws.
const PREVIEW_SAFE_TYPES: readonly MessageType[] = [MessageType.money_limits_reminder]

/** As above, but generic for any type outside the preview-safe allowlist. */
export function previewDialogComponent(type: MessageType | null | undefined): DialogComponent {
    if (!type || !PREVIEW_SAFE_TYPES.includes(type)) return NOTIFICATION_DIALOG_COMPONENTS.default

    return notificationDialogComponent(type)
}
